import React from 'react';

import { FormConsumer } from '../Form';
import { StepperConsumer } from '../Stepper';

import Material from './steps/Material';
import Finish from './steps/Finish';
import Measurements from './steps/Measurements';
import MeasurementsCurvedA from './steps/MeasurementsCurvedA';
import MeasurementsCurvedB from './steps/MeasurementsCurvedB';
import MeasurementsCurvedC from './steps/MeasurementsCurvedC';
import EndCaps from './steps/EndCaps';
import Brackets from './steps/Brackets';

const stepComponents = {
  material: Material,
  finish: Finish,
  measurements: Measurements,
  'measurements-a': MeasurementsCurvedA,
  'measurements-b': MeasurementsCurvedB,
  'measurements-c': MeasurementsCurvedC,
  'end-caps': EndCaps,
  'brackets': Brackets,
};

class Step extends React.PureComponent {
  render() {
    return (
      <StepperConsumer>
        {({ steps, step, setStep }) => {
          const stepKey = Object.keys(steps)[step];
          const StepComponent = stepComponents[stepKey] || 'div';

          return (
            <div id="mtm-step" className="small-16 large-11 large-pull-5 xlarge-12 xlarge-pull-4 columns">
              <h2 className="mtm-step-title">{`Steg ${steps[stepKey].label.replace('. ', ' – ')}`}</h2>

              <FormConsumer>
                {(formContext) => <StepComponent {...formContext} step={step} />}
              </FormConsumer>
            </div>
          );
        }}
      </StepperConsumer>
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/Step/index.js